import React, { Component } from "react";
import { Row, Col, Button, Tabs } from "antd";
import { withRouter } from "react-router-dom";
import "./Tender.css";
import TenderList from "./TenderList/TenderList";
import InvitationList from "../Invitation/InvitationList/InvitationList";
import InvitationListOpen from "../Invitation/InvitationListOpen/InvitationListOpen";
import ResultList from "../Result/ResultList";
import { API } from "../../API/API";
const { TabPane } = Tabs;
class Tender extends Component {
  state = {
    tendercount: 0,
    invcount: 0,
    invopencount: 0,
    resultcount: 0,
    defaultActiveKey: this.props.match.params.index === undefined ? 1 : this.props.match.params.index,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    let body = {
      year: "",
      quarter: "",
      month: "",
      day: "",
    };
    API.post("getTenderCounts", body).then((response) => {
      if (response.status === 200) {
        this.setState((prevState) => ({
          tendercount: response.data.retData[0][0].tendercount,
          invcount: response.data.retData[0][0].invcount,
          invopencount: response.data.retData[0][0].invopencount,
          resultcount: response.data.retData[0][0].resultcount,
          dkey: prevState.dkey + 1
        }));
      }
    });
  };
  render() {
    return (
      <div key={this.state.dkey} style={{ paddingLeft: 15 }}>
        <Tabs defaultActiveKey={this.state.defaultActiveKey}>
          <TabPane
            tab={"Тендерийн жагсаалт(" + this.state.tendercount + ")"}
            key={1}
          >
            <TenderList />
          </TabPane>
          <TabPane
            tab={"Урилгын жагсаалт(" + this.state.invcount + ")"}
            key={2}
          >
            <InvitationList opening={false} />
          </TabPane>
          <TabPane tab={"Нээлт(" + this.state.invopencount + ")"} key={3}>
            <InvitationListOpen opening={true} />
          </TabPane>
          <TabPane
            tab={"Үр дүн гарсан(" + this.state.resultcount + ")"}
            key={4}
          >
            <ResultList opening={true} isresult={true} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withRouter(Tender);
